import { useEffect, useRef } from "react";
import { useTourProgress } from "@/hooks/useTourProgress";
import { useAuth } from "@/hooks/useAuth";
import { runTour } from "./runTour";

export default function WelcomeTour() {
  const { user } = useAuth();
  const { ready, enabled, welcomeCompleted, markCompleted } = useTourProgress();
  const firedRef = useRef(false);

  useEffect(() => {
    if (!ready || !user || welcomeCompleted || !enabled || firedRef.current) return;
    firedRef.current = true;
    const id = setTimeout(async () => {
      await runTour([
        {
          element: '[data-tour="nav-mastery"]',
          popover: {
            title: "Your Mastery",
            description: "Points, tier, and the next move to level up. Earn certs you can post on LinkedIn.",
          },
        },
        {
          element: '[data-tour="nav-workspace"]',
          popover: {
            title: "The Workspace",
            description: "Run chat, image, and research with the latest models. You've got 30 minutes unrestricted to play.",
          },
        },
        {
          element: '[data-tour="nav-account"]',
          popover: {
            title: "Everything else lives here",
            description: "Squads, Library, billing, and tour replays — all under your name. You can disable these tours in Settings.",
          },
        },
      ]);
      await markCompleted("welcome");
    }, 1200);
    return () => clearTimeout(id);
  }, [ready, user, welcomeCompleted, enabled, markCompleted]);

  return null;
}